module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.9221ae4.woff";